import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["eventActionPath", "eventLabel", "eventValue", "eventInteraction", "flightDetail", "eventUX"],
    _excluded2 = ["eventActionPath", "eventLabel", "eventValue", "eventInteraction", "flightDetail", "eventUX"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import pathOr from 'ramda/src/pathOr';
import actions from './actions';
/* global dataLayer */

var withDataLayer = function withDataLayer(fn) {
  return function () {
    if (typeof dataLayer !== 'undefined') {
      fn.apply(void 0, arguments);
    }
  };
};

export var sendMyProfileLoginWidgetEvent = function sendMyProfileLoginWidgetEvent(posGA) {
  return withDataLayer(function (_ref) {
    var eventActionPath = _ref.eventActionPath,
        _ref$eventLabel = _ref.eventLabel,
        eventLabel = _ref$eventLabel === void 0 ? '' : _ref$eventLabel,
        _ref$eventValue = _ref.eventValue,
        eventValue = _ref$eventValue === void 0 ? 0 : _ref$eventValue,
        _ref$eventInteraction = _ref.eventInteraction,
        eventInteraction = _ref$eventInteraction === void 0 ? 0 : _ref$eventInteraction,
        flightDetail = _ref.flightDetail,
        eventUX = _ref.eventUX,
        other = _objectWithoutProperties(_ref, _excluded);

    var eventCategory = 'MyProfile_Login_Widget';
    var eventAction = pathOr('', [eventCategory].concat(_toConsumableArray(eventActionPath)), actions);

    if (eventAction) {
      dataLayer.push(_objectSpread({
        event: 'GAevent',
        eventCategory: eventCategory,
        eventAction: eventAction,
        eventLabel: "".concat(eventLabel).concat(eventLabel ? ';' : '', "POS:").concat(posGA),
        eventValue: eventValue,
        eventInteraction: eventInteraction,
        flightDetail: flightDetail,
        eventUX: eventUX
      }, other));
    }
  });
};
export var sendMyProfileLoginEvent = withDataLayer(function (_ref2) {
  var eventActionPath = _ref2.eventActionPath,
      _ref2$eventLabel = _ref2.eventLabel,
      eventLabel = _ref2$eventLabel === void 0 ? '' : _ref2$eventLabel,
      _ref2$eventValue = _ref2.eventValue,
      eventValue = _ref2$eventValue === void 0 ? 0 : _ref2$eventValue,
      _ref2$eventInteractio = _ref2.eventInteraction,
      eventInteraction = _ref2$eventInteractio === void 0 ? 0 : _ref2$eventInteractio,
      flightDetail = _ref2.flightDetail,
      eventUX = _ref2.eventUX,
      other = _objectWithoutProperties(_ref2, _excluded2);

  var eventCategory = 'MyProfile Login';
  var eventAction = pathOr('', [eventCategory].concat(_toConsumableArray(eventActionPath)), actions);

  if (eventAction) {
    dataLayer.push(_objectSpread({
      event: 'GAevent',
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel,
      eventValue: eventValue,
      eventInteraction: eventInteraction,
      flightDetail: flightDetail,
      eventUX: eventUX
    }, other));
  }
});